import React, { useContext, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import withConfig from '../../components/wrappers/withConfig'
import { UserContext } from '../../components/wrappers/UserContext'

dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(duration)

export default withConfig(({config}) => {
    const { client, user } = useContext(UserContext)
    const [expiresAt, setExpiresAt] = useState(null)
    const [displayTime, setDisplayTime] = useState('')

    useEffect(() => {
        if (!user) {
            localStorage.removeItem('expiresAt')
            return
        }
        const now = dayjs().valueOf()
        const expires = now + config.INACTIVITY_TIME * 1000
        setExpiresAt(expires)
        localStorage.setItem('expiresAt', expires)

        const handleClick = () => {
            const newExpiry = dayjs().valueOf() + config.INACTIVITY_TIME * 1000
            localStorage.setItem('expiresAt', newExpiry)
            setExpiresAt(newExpiry)
        }
        window.addEventListener('click', handleClick, {capture: true})
        return () => window.removeEventListener('click', handleClick, {capture: true})
    }, [user])

    useEffect(() => {
        if (!user || !expiresAt) return
        const i = setInterval(() => {
            const localStorageExpiresAt = parseInt(localStorage.getItem('expiresAt'))
            if (!localStorageExpiresAt) return
            const now = dayjs().valueOf()
            const remaining = localStorageExpiresAt - now
            if (remaining < 0) {
                clearInterval(i)
                client.signoutRedirect()
                return
            }
            const deltaT = dayjs.duration(remaining, 'milliseconds')
            setDisplayTime(`${deltaT.hours().toString().padStart(2, "0")}h ${deltaT.minutes().toString().padStart(2, "0")}m ${deltaT.seconds().toString().padStart(2, "0")}s`)
        }, 1000)
        return () => clearInterval(i)
    }, [user, expiresAt])

    if (!user) return null

    return (
        <div className="navbar-item">
            Session Expires in {displayTime}
        </div>
    )
})
